
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Home',

  data () {
    return {
      forecaste: []
    }
  },

  methods: {
    getStuff () {
      this.$axios.get('weatherforecast').then(res => {
        this.forecaste = res.data
      })
    }
  }
})
